import elementIsVisible from '../../core/INF-elementIsVisible';
import { resizeVideo } from './resizeVideos';
import initControls from './initControls';

// Make an index of videos for potential use later in theme editor
const youtube_players = {};

const youtubePlayerInit = (container, start = 0) => {
  const playerElement = container.querySelector('[data-video-player]');
  const player_id = playerElement.id;

  youtube_players[player_id] = new window.YT.Player(player_id, {
    playerVars: {
      autoplay: 0,
      controls: 0,
      autohide: 1,
      fs: 0,
      rel: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      wmode: 'opaque',
      showinfo: 0,
      loop: 1,
      mute: 1,
      playlist: container.dataset.videoId,
      start,
    },
    videoId: container.dataset.videoId,
    events: {
      onReady: () => {
        resizeVideo(container);

        // We don't want to autoplay every single video...just the one that's visible
        if (elementIsVisible(container)) {
          youtube_players[player_id].playVideo();
        }
      },
      onStateChange: (e) => {
        if (e.data !== 1) {
          return;
        }

        // Video is playing (not buffering or just "ready") and we haven't fully initialized it yet
        if (!container.classList.contains('BackgroundVideo--init')) {
          container.classList.add('BackgroundVideo--init');
          initControls(container, youtube_players[player_id], 'youtube');
        }
      },
    },
  });
};

export { youtube_players, youtubePlayerInit };
